
import moment from "moment";
//返回原生界面
export function goBack() {
  if (window.android) {
    window.android.goBack();
  } else {
    location.href = "objc://zenking:/goBack:/";
  }
}

// 修改网页标题
export const setTitle = (title) => {
  window.document.title = title || '火箭猫'
}

//时间戳格式化
export const dateFormat = function(dateStr, fmt) {
  return moment(dateStr).format(fmt)
}

// 音频时间转换格式
export const timeToFormat = (times) => {
  let result = '00:00';
  let hour, minute, second;
  if (times > 0) {
    hour = Math.floor(times / 3600);
    if (hour < 10 && hour != 0) {
      hour = "0" + hour;
    }
    minute = Math.floor((times - 3600 * hour) / 60);
    if (minute < 10 && minute != 0) {
      minute = "0" + minute;
    }

    second = Math.floor((times - 3600 * hour - 60 * minute) % 60);
    if (second < 10) {
      second = "0" + second;
    }
    result = (hour ? hour + ':' : '') + (minute || '00') + ':' + second;
  }
  return result;
}

//获得url参数
export const getUrlKey = (name) => {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}

//对字符串进行加密
export function compileStr(code){
  var c=String.fromCharCode(code.charCodeAt(0)+code.length);
  for(var i=1;i<code.length;i++){
    c+=String.fromCharCode(code.charCodeAt(i)+code.charCodeAt(i-1));
  }
  return escape(c);
}

//字符串进行解密
export function uncompileStr(code){
  code = unescape(code);
  var c=String.fromCharCode(code.charCodeAt(0)-code.length);
  for(var i=1;i<code.length;i++){
    c+=String.fromCharCode(code.charCodeAt(i)-c.charCodeAt(i-1));
  }
  return c;
}

//生成lansiID
export function creatLansiId(userId){
  let myuserId = `${userId}`
  let lansiId = ''
  for(let i=0; i< (6 - myuserId.length); i++){
    lansiId = `0${lansiId}`
  }
  lansiId = `FJ${lansiId}${myuserId}`
  return lansiId;
}

export function separateToSpan(aHTML) {
  // debugger
  //标记style属性 @@@
  var debrisList = aHTML.split("><");
  var len = debrisList.length;
  for (var i = 0; i < len; i++) {
    var debris = debrisList[i];
    // 零宽负向先行断言 (?!>) 匹配结果不包含>字符
    var match = debris.match(/(^.+="((?!>)(.|\n|\r))*"){1}/);
    if (match) {
      var substr = debris.substr(match[0].length)
      var matchstr = match[0].replace(/\s/g, "@@@");
      debrisList[i] = matchstr + substr
    }
  }
  aHTML = debrisList.join("><")

  //按规则拆分单词 添加class="word"
  aHTML = aHTML.replace(/>/g, '> ');
  aHTML = aHTML.replace(/</g, ' <');
  aHTML = aHTML.replace(/\s{2}</g, '<');

  aHTML = aHTML.trim().replace(/&nbsp;/g, ' ');
  debrisList = aHTML.split(' ');
  len = debrisList.length;

  for (var i = 0; i < len; i++) {
    var debris = debrisList[i];
    var word = debris.match(/^[`''“”""(（《]?[a-zA-Z-`’']+/);
    if (word) {

      // 后面的节点
      var otherNode = debris.split(word[0])[1];

      // 把前引号拆开
      var prefix = word[0].match(/^[`''“”""(（《]{1}/)
      if (prefix) {
        word = prefix + '<span class="word">' +  word[0].substring(1) + '</span>';
      } else {
        word = '<span class="word">' +  word + '</span>';
      }
      otherNode && (word += otherNode);
      debrisList[i] = word;
    }
  }
  aHTML = debrisList.join(' ');

  //还原style
  aHTML = aHTML.replace(/@@@/g, ' ');

  return aHTML
}





//////////////////
// WEBPACK FOOTER
// ./app/lib/util.js
// module id = null
// module chunks = 